var React = require('react');

function FooterLinkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"linkedin","d":"M44.6,0H3.467A3.466,3.466,0,0,0,0,3.465V44.583a3.466,3.466,0,0,0,3.467,3.465H44.6a3.466,3.466,0,0,0,3.467-3.465V3.465A3.466,3.466,0,0,0,44.6,0ZM17.05,36.318H11.2v-17.6H17.05ZM14.123,16.311h-.038a3.05,3.05,0,1,1,.077-6.082,3.051,3.051,0,1,1-.039,6.082ZM38.155,36.318H32.3V26.9c0-2.367-.847-3.981-2.965-3.981a3.2,3.2,0,0,0-3,2.14,4.005,4.005,0,0,0-.193,1.428v9.83H20.289s.077-15.951,0-17.6h5.853v2.492A5.811,5.811,0,0,1,31.416,18.3c3.851,0,6.738,2.516,6.738,7.922Zm0,0","fill":"#034163"}));
}

FooterLinkedin.defaultProps = {"width":"48.067","height":"48.048","viewBox":"0 0 48.067 48.048"};

module.exports = FooterLinkedin;

FooterLinkedin.default = FooterLinkedin;
